export default __webpack_public_path__ + "static/media/buratino.24a8bff0.png";